<template>
  <div>
    <div class="notification-icon">
      <div class="bicon">
        <b-icon pack="icomoon" size="is-medium" :icon="buffer.type" />
      </div>
      <span>{{ $t('compEcolabwarePlasticForm.title') }}</span>
    </div>
    <b-notification :closable="false">
      <b-field
        :label="$t('compEcolabwarePlasticForm.weight') + ' *'"
        :type="{ 'is-danger': errors.has('weight') }"
        :message="errors.first('weight')"
      >
        <b-input
          expanded
          type="number"
          v-validate="'required|numeric'"
          :placeholder="$t('compEcolabwarePlasticForm.weight') + ' *'"
          name="weight"
          @input="$emit('input', buffer)"
          v-model="buffer.weight"
        />
        <p class="control">
          <span class="button is-static">g</span>
        </p>
      </b-field>
      <b-field
        :label="$t('compEcolabwarePlasticForm.type') + ' *'"
        :type="{ 'is-danger': errors.has('type') }"
        :message="errors.first('type')"
      >
        <b-select
          expanded
          v-validate="'required'"
          name="type"
          @input="$emit('input', buffer)"
          v-model="buffer.type"
        >
          <option :value="type" v-for="(type, index) in TYPES" :key="index">
            {{ $t('compEcolabwarePlasticForm.' + type) }}
          </option>
        </b-select>
      </b-field>
      <b-field
        :label="$t('compEcolabwarePlasticForm.manufacturingArea') + ' *'"
        :type="{ 'is-danger': errors.has('manufacturingArea') }"
        :message="errors.first('manufacturingArea')"
      >
        <b-select
          expanded
          v-validate="'required'"
          :placeholder="
            $t('compEcolabwarePlasticForm.manufacturingArea') + ' *'
          "
          name="manufacturingArea"
          @input="$emit('input', buffer)"
          v-model="buffer.manufacturingArea"
        >
          <option
            :value="area"
            v-for="(area, index) in MANUFACTURING_AREA"
            :key="index"
          >
            {{ $t('compEcolabwarePlasticForm.' + area) }}
          </option>
        </b-select>
      </b-field>
      <b-field>
        <b-switch v-model="buffer.sterilized" @input="$emit('input', buffer)">
          {{ $t('compEcolabwarePlasticForm.label-1') }}
        </b-switch>
      </b-field>
      <b-field>
        <b-switch
          v-model="buffer.decontamination"
          @input="$emit('input', buffer)"
        >
          {{ $t('compEcolabwarePlasticForm.label-2') }}
        </b-switch>
      </b-field>
    </b-notification>
  </div>
</template>

<script>
import { PlasticLabWare } from '@/models/plastic/LabWare.js'

export default {
  name: 'PlasticForm',
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      TYPES: PlasticLabWare.TYPES,
      MANUFACTURING_AREA: PlasticLabWare.MANUFACTURING_AREA,
      buffer: PlasticLabWare.createFromObj(this.value)
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = PlasticLabWare.createFromObj(this.value)
      },
      deep: true
    }
  }
}
</script>
